//#region src/components/Tree/helpers/getVisibleNodes.tsx
var e = (t, n, r = 0) => {
	let i = [];
	for (let a of t) i.push({
		depth: r,
		node: a
	}), a.children && n.has(a.id) && i.push(...e(a.children, n, r + 1));
	return i;
};
//#endregion
export { e as getVisibleNodes };
